import * as React from 'react';
import { QuickLoginFormView } from './QuickLoginFormView';
import { withLogin } from 'ts/login/hoc/Login/withLogin';
import { WrappedLoginComponentProps } from 'ts/login/hoc/Login/interfaces';

interface QuickLoginFormProps extends WrappedLoginComponentProps {
  username: string;
}

/**
 * Reusable login form that allows the user to enter only their
 * password to login. It contains a hidden username input for autocomplete.
 */
const QuickLoginComponent: React.FC<QuickLoginFormProps> = ({
  username,
  // the rest of the props come from the hoc
  error,
  loading,
  password,
  loginSubmit,
  handlePasswordOnChange,
  passwordError,
}) => {
  return (
    <QuickLoginFormView
      loading={loading}
      username={username}
      loginError={error}
      password={password}
      loginSubmit={loginSubmit}
      onPasswordChange={handlePasswordOnChange}
      passwordError={passwordError}
    />
  );
};

const QuickLoginForm = withLogin(QuickLoginComponent);

export { QuickLoginForm };
